
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function PrivatePilot() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-teal-600 to-teal-700 text-white py-20">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=private%20pilot%20flying%20aircraft%20over%20texas%20landscape%20with%20unlimited%20freedom%2C%20professional%20aviation%20training%20scene%2C%20clear%20blue%20skies%20and%20beautiful%20countryside%20below%2C%20modern%20flight%20training%20aircraft&width=1200&height=600&seq=private-pilot-hero&orientation=landscape')`,
            }}
          >
            <div className="absolute inset-0 bg-black/40"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Private Pilot License
              </h1>
              <h2 className="text-3xl font-semibold mb-4">Freedom to Fly When You Want</h2>
              <p className="text-xl mb-8 leading-relaxed">
                From those desiring a career in aviation to the pilots who want the freedom of travel without restrictions, Private Pilot Licensure is the first step for the majority of aviators across the USA.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="tel:706-936-8961" 
                  className="bg-white text-teal-600 px-8 py-3 rounded-md text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block text-center"
                >
                  Call: 706-936-8961
                </a>
                <a 
                  href="tel:512-658-3132" 
                  className="border-2 border-white text-white px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer inline-block text-center"
                >
                  Scott: 512-658-3132
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-4xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Come by and Visit!
              </h2>
              <p className="text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
                Learning to fly in the relaxed environment here at Stiletto airpark is as easy and cost effective as it gets!
              </p>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-16 bg-teal-600 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
              Begin Your Private Pilot Journey
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Take the first step toward unlimited flying freedom. Start your Private Pilot training at Stiletto Airpark and discover the joy of aviation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:706-936-8961" 
                className="bg-white text-teal-600 px-8 py-3 rounded-md text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Call Bryson: 706-936-8961
              </a>
              <a 
                href="tel:512-658-3132" 
                className="border-2 border-white text-white px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Call Scott: 512-658-3132
              </a>
            </div>
            
            <div className="mt-8">
              <Link 
                to="/" 
                className="text-teal-200 hover:text-white transition-colors"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
